import { shallowEqual } from "react-redux";
import { Panel } from "components/Panel/Panel";
import { trackTournaments } from "app/slices/TournamentSlice";
import { PanelLoadingSpinner } from "components/Panel/styles";
import { ReactNode } from "react";
import {
  selectAllTrackedTournamentsLoaded,
  selectTournamentsNotTracked,
} from "selectors/TournamentLoading";
import { SingleColumnPage } from "./PageTemplates";
import { useAppDispatch, useAppSelector } from "app/hooks";

interface Props {
  children: ReactNode;
  tournamentIds: string[];
}
export const TournamentLoader = ({ children, tournamentIds }: Props) => {
  const dispatch = useAppDispatch();

  const tournamentsToTrack = useAppSelector(
    (state) => selectTournamentsNotTracked(state, tournamentIds),
    shallowEqual
  );

  const tournamentsLoaded = useAppSelector(selectAllTrackedTournamentsLoaded);

  if (tournamentsToTrack.length > 0) {
    dispatch(
      trackTournaments({
        initialLoad: false,
        tournamentIds: tournamentsToTrack,
      })
    );
  }
  if (!tournamentsLoaded) {
    return (
      <SingleColumnPage>
        <Panel>
          <PanelLoadingSpinner />
        </Panel>
      </SingleColumnPage>
    );
  }

  return <>{children}</>;
};
